import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectCommonUsers = (state: StoreSchema) =>
    state.commonData.common.users
